import * as React from 'react';
const IconPwaInstallButton = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={112}
    height={112}
    style={{ width: 112, height: 112 }}
    viewBox="0 0 112 112"
    fill="none"
    {...props}
  >
    <g filter="url(#filter0_d_1154_2782)">
      <circle cx={55.6897} cy={55.6897} r={47.5} fill="white" />
    </g>
    <rect
      x={39.0445}
      y={26.7601}
      width={32.5111}
      height={57.7896}
      rx={6.00855}
      fill="#97CDDA"
      stroke="#003764"
      strokeWidth={4.38193}
    />
    <mask id="path-3-inside-1_1154_2782" fill="white">
      <rect x={45.7351} y={24.5691} width={18.4465} height={8.19844} rx={2.15777} />
    </mask>
    <rect
      x={45.7351}
      y={24.5691}
      width={18.4465}
      height={8.19844}
      rx={2.15777}
      fill="#003764"
      stroke="#003764"
      strokeWidth={8.19844}
      mask="url(#path-3-inside-1_1154_2782)"
    />
    <circle cx={70.1419} cy={48.3634} r={12.8395} fill="#F7EBB1" stroke="#003764" strokeWidth={4.38193} />
    <path
      d="M70.5973 42.7368L70.5973 51.6184"
      stroke="#003764"
      strokeWidth={4.38193}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.4981 49.5691L70.5973 53.6683L74.6965 49.5691"
      stroke="#003764"
      strokeWidth={4.38193}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_1154_2782"
        x={0.0000419617}
        y={0.0000419617}
        width={111.379}
        height={111.379}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={4.09483} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1154_2782" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1154_2782" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default IconPwaInstallButton;
